/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCorrectExamAnsweridQueryResponse,
  GetApiV1ExamCorrectExamAnsweridPathParams,
  GetApiV1ExamCorrectExamAnswerid400,
  GetApiV1ExamCorrectExamAnswerid401,
  GetApiV1ExamCorrectExamAnswerid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectExamAnswerid.ts";

function getGetApiV1ExamCorrectExamAnsweridUrl(
  answerId: GetApiV1ExamCorrectExamAnsweridPathParams["answerId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/correct-exam/${answerId}` as const,
  };
  return res;
}

/**
 * @description Retorna o modelo de correção de texto para uma resposta específica do exame. **(Requer Authorization para autenticação)**
 * @summary Obtenha o modelo de correção de exame (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correct-exam/:answerId}
 */
export async function getApiV1ExamCorrectExamAnswerid(
  answerId: GetApiV1ExamCorrectExamAnsweridPathParams["answerId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCorrectExamAnsweridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectExamAnswerid400
      | GetApiV1ExamCorrectExamAnswerid401
      | GetApiV1ExamCorrectExamAnswerid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCorrectExamAnsweridUrl(answerId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
